/*
 * Counterpoint, 22 Oct 2026 (add on 2). Who we work with: brand modals.
 * A tile opens its native <dialog> with showModal(), so focus moves into it and Esc closes it. A tap on the
 * backdrop or the close button closes it too. The page behind stays put through the theme's own scroll lock
 * events, and focus returns to the tile on close. The collage is stamped from a <template> on first open, and its
 * images are lazy, so each loads as it scrolls into view.
 */
(function () {
  'use strict';

  function openModal(button) {
    var dialog = document.getElementById(button.getAttribute('aria-controls'));
    if (!dialog || dialog.open) return;
    var target = dialog.querySelector('[data-cp-partner-gallery-target]');
    var tpl = dialog.querySelector('template[data-cp-partner-gallery]');
    if (target && tpl && !target.hasChildNodes()) target.appendChild(tpl.content.cloneNode(true));
    dialog.cpOpener = button;
    dialog.showModal();
    var panel = dialog.querySelector('.cp-partner-modal__panel');
    if (panel) panel.scrollTop = 0;
    document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: panel || dialog }));
    button.setAttribute('aria-expanded', 'true');
  }

  function onClose(dialog) {
    document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    var opener = dialog.cpOpener;
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      opener.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-cp-partner-open]');
    if (open) {
      e.preventDefault();
      openModal(open);
      return;
    }
    var close = e.target.closest('[data-cp-partner-close]');
    if (close) {
      var d = close.closest('dialog');
      if (d && d.open) d.close();
      return;
    }
    // A tap on the backdrop lands on the dialog element itself, outside its inner panel.
    if (e.target.matches && e.target.matches('dialog.cp-partner-modal[open]')) e.target.close();
  });

  document.addEventListener('close', function (e) {
    if (e.target.matches && e.target.matches('dialog.cp-partner-modal')) onClose(e.target);
  }, true);
})();
